import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import {
  FlexRowCenterVertical,
  FlexColCenter,
} from '../../Defaults/Flexbox/Flexbox';

interface Props {
  images: any[];
  openModal: (index) => void;
  width?: number;
  height?: number;
  marginRight?: number;
  isHomepage?: boolean;
}

function ImageGalleryThumbnails({
  images,
  openModal,
  width = 94,
  height = 94,
  marginRight = 16,
  isHomepage = false,
}: Props) {
  return (
    <>
      <GalleryWrapper>
        {images &&
          images.map((image, i) => {
            const condition = isHomepage ? i >= 0 && i < 5 : i > 0 && i < 5;
            width = isHomepage ? 70 : 94;
            height = isHomepage ? 47 : 94;
            if (condition) {
              return (
                <ThumbnailWrapper
                  // tslint:disable-next-line:jsx-no-lambda
                  onClick={() => openModal(i)}
                  width={width}
                  height={height}
                  marginRight={marginRight}
                  isHomepage={isHomepage}
                >
                  <Thumbnail
                    src={image.thumbnail}
                    alt={__('Obrázok')}
                    isHomepage={isHomepage}
                  />
                </ThumbnailWrapper>
              );
            }
            if (i === 5 && !isHomepage) {
              return (
                // tslint:disable-next-line:jsx-no-lambda
                <ThumbnailWrapper onClick={() => openModal(i)}>
                  <u>+{images.length - 5}</u>
                </ThumbnailWrapper>
              );
            }
            return null;
          })}
      </GalleryWrapper>

      <GalleryWrapperMobile>
        {images &&
          images.map((image, i) => {
            const condition = isHomepage ? i >= 0 && i < 5 : i > 0 && i < 3;
            width = isHomepage ? 66 : 94;
            height = isHomepage ? 44 : 94;

            if (condition) {
              return (
                <ThumbnailWrapper
                  // tslint:disable-next-line:jsx-no-lambda
                  onClick={() => openModal(i)}
                  width={width}
                  height={height}
                  marginRight={marginRight}
                  isHomepage={isHomepage}
                >
                  <Thumbnail
                    src={image.thumbnail}
                    alt={'Obrázok'}
                    isHomepage={isHomepage}
                  />
                </ThumbnailWrapper>
              );
            }
            if (i === 3 && !isHomepage) {
              return (
                // tslint:disable-next-line:jsx-no-lambda
                <ThumbnailWrapper onClick={() => openModal(i)}>
                  <u>+{images.length - 3}</u>
                </ThumbnailWrapper>
              );
            }
            return null;
          })}
      </GalleryWrapperMobile>
    </>
  );
}

const GalleryWrapper = styled(FlexRowCenterVertical)`
  margin: ${rem(16)} 0 ${rem(0)};

  ${({ theme }) => theme.mediab.l925`
    margin: ${rem(16)} auto ${rem(48)};
  `}

  ${({ theme }) => theme.mediab.s450`
    display: none;
  `}
`;

const GalleryWrapperMobile = styled(FlexRowCenterVertical)`
  display: none;
  margin: ${rem(32)} 0 ${rem(48)} 0;

  ${({ theme }) => theme.mediab.s450`
  display: flex;
`}
`;

const Thumbnail = styled.img<{ isHomepage }>`
  width: ${rem(72)};
  height: ${rem(72)};
  margin: ${({ isHomepage }) => (isHomepage ? 0 : rem(11))};
  cursor: pointer;
`;

const ThumbnailWrapper = styled(FlexColCenter)<{
  width;
  height;
  marginRight;
  isHomepage;
}>`
  width: ${({ width }) => (width ? rem(width) : rem(94))};
  height: ${({ height }) => (height ? rem(height) : rem(94))};
  margin-right: ${({ marginRight }) => rem(marginRight)};
  cursor: pointer;
  border-radius: ${rem(4)};
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.primary};
  line-height: ${rem(18)};
  color: ${({ theme }) => theme.colors.black};
  overflow: hidden;

  ${({ theme }) => theme.mediab.s450`
    width: ${({ isHomepage, width }) => (isHomepage ? rem(width) : rem(85))};
    height: ${({ isHomepage, height }) => (isHomepage ? rem(height) : rem(85))};
  `}
`;

export { ImageGalleryThumbnails };
